export default __webpack_public_path__ + "static/stackingrings-1f6d3ca574969135be39eb41b6fbe524.png";